<app-menu></app-menu>
<div class="success-page-container">
    <div class="success-card">

        <div class="illustration-container">
            <svg class="success-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                <circle class="checkmark-circle" cx="26" cy="26" r="25" fill="none" />
                <path class="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
            </svg>
        </div>

        <h1>Compra Realizada com Sucesso!</h1>
        <p>
            Obrigado por comprar conosco! Enviamos um e-mail de confirmação com todos
            os detalhes do seu pedido. Seus livros já estão sendo preparados para envio.
        </p>

        <a routerLink="/minhas-compras" class="details-button">
            Ver Detalhes da Compra
        </a>

    </div>
</div>

<app-footer></app-footer>